import React from "react"
import style from "../components/kijkItemMobile.module.scss"
import ReactPlayer from "react-player/soundcloud"

export default function LuisterItemMobile({ beeld, geluid, info, mediaType }) {
  return (
    <div className={style.wrapper}>
      <div className={style.beeld}>
        <ReactPlayer
          width="100%"
          height="100%"
          className={style.player}
          url={geluid}
          style={{ gridColumn: "1/-1" }}
        ></ReactPlayer>
      </div>
      <div className={style.info} style={{ backgroundColor: `#bdecbd` }}>
        <h3>{`${info.voornaam} ${info.achternaam}`}</h3>
        {/* {info.link && <a href = {info.link} target = '_blank'>Video &#10132;</a>} */}
        {/* <h5>Locatie:<br/>{info.locatie}</h5> */}
        <h4>{info.voornaam === "FASadE" ? info.programmaType : `PODCAST`}</h4>
      </div>
    </div>
  )
}
